<template>
  <div class="menu-topping">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong class="first">
                <h3>
                  <router-link :to="{ name: 'menu_list'}" class="float-left mr-1 main-link">{{$t('menu.menus')}}</router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'menu_edit',  params: { id: id }}" class="float-left mr-1 main-link">{{$t('menu.detail')}}</router-link>
                  / {{$t('menu.topping_detail')}}
                </h3>
              </strong>
            </div>
          </div>
        </b-col>
      </b-row>

      <b-card header-tag="header" footer-tag="footer" body-class="p-3">
        <div slot="header">
          <strong class="uppercase">{{ $t('menu.topping_detail') }}</strong>
        </div>
        <div class="row">
          <div class="topping-header col-12">
            <div class="topping-search">
              <div class="topping-label">{{$t('menu.default_topping')}}</div>
              <div class="topping-input">
                <b-input-group v-show="single.config.edit_topping">
                  <div class="input-group-prepend">
                    <b-input-group-append>
                      <div class="input-group-text"><i class="fa fa-search" ></i></div>
                    </b-input-group-append>
                  </div>
                  <b-form-input v-model="default_topping_key" v-bind:placeholder="$t('menu.search_topping')"></b-form-input>
                </b-input-group>
                <div class="full-width">
                  <span class="selected-topping" v-for="(topping,i) in default_topping_ids" :key="topping.topping_id" v-if="checkDefaultTopping(topping.topping_id) > 0 && source_default_toppings[$session.get('lang')] != null && source_default_toppings[$session.get('lang')]['id_'+topping.topping_id] != null">
                    <vue-numeric-input  class="topping-quantity-input" v-model="default_topping_ids[i].default_quantity" :min="1" :max="99" align="center" size="45px" :controls="false"></vue-numeric-input>
                    <span class="ml-2">{{ source_default_toppings[$session.get('lang')]['id_'+topping.topping_id].text.trim() }}</span>
                    <span class="close-btn" @click="removeDefaultTopping(topping.topping_id)" v-show="single.config.edit_topping">
                      <i class="fa fa-angle-right"></i>
                      <i class="fa fa-angle-left"></i>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="topping-body-list">
              <div class="topping-list" v-show="single.config.edit_topping" v-for="(default_topping, typeSpecial) in default_toppings[$session.get('lang')]">
                <div class="topping-list-header">
                  <h2 class="watermark desktop cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr float-left">
                    <span class="fs-30 pr-7 ">{{$t('topping.type_specials_' + typeSpecial)}}</span>
                  </h2>
                  <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3 float-right" @click="openFormPopup(typeSpecial)"  v-show="single.config.update_topping_rule_mapping">{{$t('topping.update_topping_rule_mapping')}}</button>
                </div>
                <b-row>
                  <b-col cols="3" v-for="topping in default_topping" :key="topping.id" class="topping-item">
                    <span @click="addDefaultTopping(topping.id)" :id="`default_${$t(`topping.type_specials_${typeSpecial}`)}_${topping.id}`"><i class="fa fa-plus btn-circle"></i> {{ topping.text.trim() }}</span>
                    <b-tooltip :target="`default_${$t(`topping.type_specials_${typeSpecial}`)}_${topping.id}`" triggers="hover">
                      <span class="d-block">{{ $t('topping.sku') }}: <b>{{ topping.sku }}</b></span>
                      <span class="d-block">{{ $t('topping.short_name') }}: <b>{{ topping.short_name }}</b></span>
                      <span class="d-block">{{ $t('topping.name_seo') }}: <b>{{ topping.name_seo }}</b></span>
                    </b-tooltip>
                  </b-col>
                </b-row>
              </div>
            </div>
           </div>
          <div class="topping-header col-12">
            <div class="topping-search">
              <div class="topping-label">{{$t('menu.extra_topping')}}</div>
              <div class="topping-input">
                <b-input-group v-show="single.config.edit_topping">
                  <div class="input-group-prepend">
                    <b-input-group-append>
                      <div class="input-group-text"><i class="fa fa-search" ></i></div>
                    </b-input-group-append>
                  </div>
                  <b-form-input v-model="extra_topping_key" v-bind:placeholder="$t('menu.search_topping')"></b-form-input>
                </b-input-group>
                <div class="full-width">
                  <span :class="'selected-topping' + (source_extra_toppings[$session.get('lang')]['id_'+topping.topping_id].special == '1' ? ' special' : '')" v-for="(topping,i) in extra_topping_ids" :key="topping.topping_id" v-if="checkExtraTopping(topping.topping_id) > 0 && source_extra_toppings[$session.get('lang')] != null && source_extra_toppings[$session.get('lang')]['id_'+topping.topping_id] != null">
                   <vue-numeric-input class="topping-quantity-input" v-model="extra_topping_ids[i].default_quantity" :min="1" :max="99" align="center" size="45px" :controls="false"></vue-numeric-input>
                   <span class="ml-2"> {{ source_extra_toppings[$session.get('lang')]['id_'+topping.topping_id].text.trim() }}</span>
                   <span class="close-btn" @click="removeExtraTopping(topping.topping_id)" v-show="single.config.edit_topping">
                      <i class="fa fa-angle-right"></i>
                      <i class="fa fa-angle-left"></i>
                   </span>
                  </span>
                </div>
              </div>
            </div>
            <div class="topping-list">
              <div class="topping-list" v-show="single.config.edit_topping" v-for="(extra_topping, typeSpecial) in extra_toppings[$session.get('lang')]">
                <div class="topping-list-header">
                  <h2 class="watermark desktop cond caps xs-my-20 xs-mx-10 xs-text-center heading-hr float-left">
                    <span class="fs-30 pr-7 ">{{$t('topping.type_specials_' + typeSpecial)}}</span>
                  </h2>
                  <button type="button" class="btn bg-main border-radius-4px pl-3 pr-3 float-right" @click="openFormPopup(typeSpecial)"  v-show="single.config.update_topping_rule_mapping">{{$t('topping.update_topping_rule_mapping')}}</button>
                </div>
                <b-row>
                <b-col cols="3" v-for="topping in extra_topping" :key="topping.id" class="topping-item">
                  <span @click="addExtraTopping(topping.id)" :class="topping.special == '1' ? 'special' : ''" :id="`extra_${$t(`topping.type_specials_${typeSpecial}`)}_${topping.id}`"><i class="fa fa-plus btn-circle"></i> {{ topping.text.trim() }}</span>
                  <b-tooltip :target="`extra_${$t(`topping.type_specials_${typeSpecial}`)}_${topping.id}`" triggers="hover">
                    <span class="d-block">{{ $t('topping.sku') }}: <b>{{ topping.sku }}</b></span>
                    <span class="d-block">{{ $t('topping.short_name') }}: <b>{{ topping.short_name }}</b></span>
                    <span class="d-block">{{ $t('topping.name_seo') }}: <b>{{ topping.name_seo }}</b></span>
                  </b-tooltip>
                </b-col>
              </b-row>
            </div>
            </div>
          </div>
        </div>

        <div slot="footer">
          <button type="button" class="btn border-radius-4px bg-main float-left ml-4" @click="$router.back()"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</button>
          <div class="btn-save">
            <button class="btn bg-main border-radius-4px btn-main pl-3 pr-3" v-on:click="saveItem()" v-if="single.config.edit_topping && !processing">{{$t('common.save')}}</button>
          </div>
        </div>
      </b-card>
    </div>
    <b-modal ref="toppingRuleMappingForm" size="lg" hide-footer hide-header>
      <topping-rule-mapping-form type="single" :topping_special="topping_special" :uuid="item.uuid" @cancel="closeFormPopup" @success="closeFormPopup"></topping-rule-mapping-form>
    </b-modal>
  </div>
</template>
<style scoped>
  .menu-topping .switch.switch-icon{
    margin-top: 5px;
  }

  .menu-topping .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .menu-topping .header-custom-switch .col-form-label{
    text-align: right;
  }

  .menu-topping .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .menu-topping .header-custom-switch .uppercase .first{
    margin-right: 10px;
  }

  .menu-topping .header-custom-switch .uppercase .last{
    margin-left: 10px;
  }

  .menu-topping .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }
  .menu-topping .btn-save{
    float: right;
    margin-right: 22px;
  }
  .btn-circle {
    border: 1px solid #0091ff;
    border-radius: 50%;
    color: #0091ff;
    width: 15px;
    height: 15px;
    text-align: center;
  }
  .close-btn {
    font-size: 18px;
    cursor: pointer;
    float: right;
    line-height: 18px;
    margin-left: 10px;
    color: #2a2c36;
  }
  .close-btn .fa-angle-right {
    margin-right: -4px;
  }
  .close-btn .fa-angle-left {
    margin-left: -4px;
  }
  .menu-topping .card,
  .menu-topping .card header.card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }
  .menu-topping .card .card-body {
    padding-top: 0px;
  }
  .topping-search {
    width: 100%;
    display: flex;
    background: #e1e6eb;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    padding: 20px;
  }
  .topping-label {
    width: auto;
    padding-right: 20px;
    line-height: 35px;
    font-weight: 600;
  }
  .topping-input {
    flex: 1;
  }
  .topping-input .input-group-text {
    background: #fff !important;
    border-right: none !important;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  .topping-input input {
    border-left: none !important;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  .selected-topping {
    background: #82909b;
    padding: 7px 10px;
    border-radius: 30px;
    margin-right: 15px;
    color: #fff;
    margin-top: 10px;
    float: left;
    display: flex;
    align-items: center;
  }
  .selected-topping.special {
    background: #1cdd6e;
  }

  .topping-list-header {
    padding-bottom: 5px;
    border-bottom: 1px solid #c2cfd6;
    width: 100%;
    display: inline-block;
  }

  .topping-body-list {
    width: 100%;
    padding: 20px;
    background: #f5f7f9;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-bottom: 20px;
  }

  .topping-list {
    width: 100%;
    padding: 20px;
    background: #f5f7f9;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    margin-bottom: 20px;
  }
  .topping-item {
    padding: 5px 15px;
    cursor: pointer;
  }
  .topping-list span {
    border-radius: 20px;
    padding: 2px 10px 2px 5px;
  }
  .topping-list span.special {
    background-color: #1cdd6e;
  }
</style>
<script>
import cSwitch from '../../../components/Switch'
import MaskedInput from 'vue-text-mask'
import VueNumericInput from 'vue-numeric-input'
import ToppingRuleMappingForm from "./ToppingRuleMappingForm"

let vm = null

export default {
  name: 'MenuTopping',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    cSwitch,
    MaskedInput,
    VueNumericInput,
    ToppingRuleMappingForm
  },
  data: function () {
    return {
      single: this.$store.getters.config.gms.menu,
      item: this.$session.get('single'),
      default_topping_ids: [],
      extra_topping_ids: [],
      default_topping_key: '',
      extra_topping_key: '',
      default_toppings: {},
      extra_toppings: {},
      source_default_toppings: {},
      source_extra_toppings: {},
      processing: false,
      topping_special: ''
    }
  },
  methods: {
    addExtraTopping (val) {
      let exist = false
      for (let i in this.extra_topping_ids) {
        if (this.extra_topping_ids[i].topping_id == val) {
          exist = true
        }
      }
      if (!exist) {
        this.extra_topping_ids.push({
          topping_id: val,
          default_quantity: 1
        })
      }
    },
    addDefaultTopping (val) {
      let exist = false
      for (let i in this.default_topping_ids) {
        if (this.default_topping_ids[i].topping_id == val) {
          exist = true
        }
      }
      if (!exist) {
        this.default_topping_ids.push({
          topping_id: val,
          default_quantity: 1
        })
      }
    },
    removeExtraTopping (val) {
      let extraTopping = []
      for (let i in this.extra_topping_ids) {
        if (this.extra_topping_ids[i].topping_id != val) {
          extraTopping.push(this.extra_topping_ids[i])
        }
      }
      this.extra_topping_ids = extraTopping
    },
    removeDefaultTopping (val) {
      let defaultTopping = []
      for (let i in this.default_topping_ids) {
        if (this.default_topping_ids[i].topping_id != val) {
          defaultTopping.push(this.default_topping_ids[i])
        }
      }
      this.default_topping_ids = defaultTopping
    },
    /**
     * check check-box of default toppings is check or not
     * @param val
     * @returns {*}
     */
    checkDefaultTopping (val) {
      for (let i in this.default_topping_ids) {
        if (this.default_topping_ids[i].topping_id == val) {
          return val
        }
      }
      return -val
    },
    /**
     * check check-box of extra toppings is check or not
     * @param val
     * @returns {*}
     */
    checkExtraTopping (val) {
      for (let i in this.extra_topping_ids) {
        if (this.extra_topping_ids[i].topping_id == val) {
          return val
        }
      }
      return -val
    },
    /**
     * convert data format then update item, then back to list page
     */
    saveItem () {
      let item = this._.cloneDeep(vm.item)

      let defaults = item.toppings.default
      let extras = item.toppings.extra

      // process default toppings data
      item.toppings.default = []
      item.toppings.extra = []
      for (let i in vm.default_topping_ids) {
        item.toppings.default.push(vm.default_topping_ids[i])
      }
      // process extra toppings data
      for (let i in vm.extra_topping_ids) {
        item.toppings.extra.push(vm.extra_topping_ids[i])
      }

      // call an API to save menu information
      vm.processing = true
      vm.axios.updateMenuTopping({uuid: vm.id, toppings: item.toppings}, function (response) {
        vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        vm.processing = false
        vm.$session.set('single', item)
        // vm.$router.push({name: 'menu_list'})
      }, function () {
        vm.processing = false
      })
    },
    getExtraAndDefaultToppingsData () {
      // set selected value for default and extra values
      vm.default_topping_ids = []
      vm.extra_topping_ids = []

      for (let i = 0; i < vm.item.toppings.default.length; i++) {
        vm.default_topping_ids.push({
          'topping_id': vm.item.toppings.default[i].topping_id,
          'default_quantity': vm.item.toppings.default[i].default_quantity
        })
      }
      for (let i = 0; i < vm.item.toppings.extra.length; i++) {
        vm.extra_topping_ids.push({
          'topping_id': vm.item.toppings.extra[i].topping_id,
          'default_quantity': vm.item.toppings.extra[i].default_quantity
        })
      }

      // set default and extra toppings for menu
      vm.axios.getExtraAndDefaultToppings(function (response) {
        for (let i in vm.$store.getters.languages) {
          vm.default_toppings[vm.$store.getters.languages[i]] = {}
          vm.extra_toppings[vm.$store.getters.languages[i]] = {}

          vm.source_default_toppings[vm.$store.getters.languages[i]] = {}
          vm.source_extra_toppings[vm.$store.getters.languages[i]] = {}

          for (let t in response.data.data.items.default) {
            let it = response.data.data.items.default[t]
            if (!vm.default_toppings[vm.$store.getters.languages[i]].hasOwnProperty(it.special)) {
              vm.default_toppings[vm.$store.getters.languages[i]][it.special] = []
            }
            if (it.name[vm.$store.getters.languages[i]] && it.name[vm.$store.getters.languages[i]] != undefined && it.name[vm.$store.getters.languages[i]] != null) {
              let item = {
                'id': it.id,
                'text': it.name[vm.$store.getters.languages[i]],
                'special': it.special,
                'name_seo': it.name_seo,
                'sku': it.sku,
                'short_name': it.short_name
              }
              // debugger
              vm.default_toppings[vm.$store.getters.languages[i]][it.special].push(item)
              vm.source_default_toppings[vm.$store.getters.languages[i]]['id_' + it.id] = item
            }
          }

          // process data for extra value
          for (let t in response.data.data.items.extra) {
            let it = response.data.data.items.extra[t]
            if (!vm.extra_toppings[vm.$store.getters.languages[i]].hasOwnProperty(it.special)) {
              vm.extra_toppings[vm.$store.getters.languages[i]][it.special] = []
            }
            if (it.name[vm.$store.getters.languages[i]] && it.name[vm.$store.getters.languages[i]] != undefined && it.name[vm.$store.getters.languages[i]] != null) {
              let item = {
                'id': it.id,
                'text': it.name[vm.$store.getters.languages[i]],
                'special': it.special,
                'name_seo': it.name_seo,
                'sku': it.sku,
                'short_name': it.short_name
              }
              // debugger
              vm.extra_toppings[vm.$store.getters.languages[i]][it.special].push(item)
              vm.source_extra_toppings[vm.$store.getters.languages[i]]['id_' + it.id] = item
            }
          }
        }
        vm.$forceUpdate('default_toppings')
        vm.$forceUpdate('extra_toppings')
        vm.$forceUpdate('source_default_toppings')
        vm.$forceUpdate('source_extra_toppings')
      })
    },
    openFormPopup (topping_special) {
      this.topping_special = topping_special
      this.$refs['toppingRuleMappingForm'].show()
    },
    closeFormPopup () {
      this.topping_special = ''
      this.$refs['toppingRuleMappingForm'].hide()
    },
  },
  created: function () {
    vm = this
  },
  mounted: function () {
    vm.getExtraAndDefaultToppingsData()
  },
  watch: {
    default_topping_key: function () {
      let default_toppings = {}
      for (let t in vm.source_default_toppings[vm.$session.get('lang')]) {
        if (vm.source_default_toppings[vm.$session.get('lang')][t].text.indexOf(vm.default_topping_key) >= 0) { // existed
          if (!default_toppings.hasOwnProperty(vm.source_default_toppings[vm.$session.get('lang')][t].special)) {
            default_toppings[vm.source_default_toppings[vm.$session.get('lang')][t].special] = []
          }
          default_toppings[vm.source_default_toppings[vm.$session.get('lang')][t].special].push(vm.source_default_toppings[vm.$session.get('lang')][t])
        }
      }
      vm.default_toppings[vm.$session.get('lang')] = default_toppings
    },
    extra_topping_key: function () {
      let extra_toppings = {}
      for (let t in vm.source_extra_toppings[vm.$session.get('lang')]) {
        if (vm.source_extra_toppings[vm.$session.get('lang')][t].text.indexOf(vm.extra_topping_key) >= 0) { // existed
          if (!extra_toppings.hasOwnProperty(vm.source_extra_toppings[vm.$session.get('lang')][t].special)) {
            extra_toppings[vm.source_extra_toppings[vm.$session.get('lang')][t].special] = []
          }
          extra_toppings[vm.source_extra_toppings[vm.$session.get('lang')][t].special].push(vm.source_extra_toppings[vm.$session.get('lang')][t])
        }
      }
      vm.extra_toppings[vm.$session.get('lang')] = extra_toppings
    }
  }
}
</script>

<style scoped>
  .default-topping,
  .extra-topping{
    margin-left: 5px;
    margin-top: 8px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/menu/ToppingForm.vue